<template>
	<WizardInputFieldLayout title="Icon">
		<template #input>
			<IconStyleEditor class="icon-editor" :allowColor="true" :btnSettings.sync="btnSettings" />
		</template>
	</WizardInputFieldLayout>
</template>

<script>
import WizardInputFieldLayout from '@/components/common/WizardInputFieldLayout.vue';
import IconStyleEditor from '@/components/BlockEditor/ButtonEditorDrawer/tabs/IconStyleEditor.vue';

export default {
	name: 'ButtonDropdownIconInputField',
	components: { WizardInputFieldLayout, IconStyleEditor },
	props: { color: { type: String }, icon: { type: String } },
	computed: {
		btnSettings: {
			get() {
				return {
					icon: {
						fillColor: this.color,
						name: this.icon,
					},
				};
			},
			set(value) {
				this.$emit('update:color', value.icon.fillColor);
				this.$emit('update:icon', value.icon.name);
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.icon-editor {
	width: 240px;
}
</style>
